
import { Placement } from '@post-office/placements-frontend/jira-plans-release-date';
export default Placement;
